import HeroTitle from '#app/components/titles/hero-title.tsx'
import { useTranslation } from 'react-i18next'

const testimonials2 = [
    {
        key: "1",
        body: 'clientFeedback.index.testimonials.0.body',
        author: {
            name: 'clientFeedback.index.testimonials.0.author',
            imageUrl:
                '/img/avatar/michael-saruna.jpeg',
        },
    },
    {
        key: "2",
        body: 'clientFeedback.index.testimonials.1.body',
        author: {
            name: 'clientFeedback.index.testimonials.1.author',
            imageUrl:
                '/img/avatar/heather-hartley.jpeg',
        },
    },
    {
        key: "3",
        body: 'clientFeedback.index.testimonials.2.body',
        author: {
            name: 'clientFeedback.index.testimonials.2.author',
            imageUrl:
                '/img/avatar/romana.png',
        },
    },
    {
        key: "4",
        body: 'clientFeedback.index.testimonials.3.body',
        author: {
            name: 'clientFeedback.index.testimonials.3.author',
            imageUrl:
                '/img/avatar/shaun.png',
        },
    },
    {
        key: "5",
        body: 'clientFeedback.index.testimonials.4.body',
        author: {
            name: 'clientFeedback.index.testimonials.4.author',
            imageUrl:
                '/img/avatar/clubb.png',
        },
    },
    {
        key: "6",
        body: 'clientFeedback.index.testimonials.5.body',
        author: {
            name: 'clientFeedback.index.testimonials.5.author',
            imageUrl:
                '/img/avatar/lavoy.png',
        },
    },
    {
        key: "7",
        body: 'clientFeedback.index.testimonials.6.body',
        author: {
            name: 'clientFeedback.index.testimonials.6.author',
            imageUrl:
                '/img/avatar/evergreen.png',
        },
    },
    {
        key: "8",
        body: 'clientFeedback.index.testimonials.7.body',
        author: {
            name: 'clientFeedback.index.testimonials.7.author',
            imageUrl:
                '/img/avatar/mark.png',
        },
    },
    {
        key: "9",
        body: 'clientFeedback.index.testimonials.8.body',
        author: {
            name: 'clientFeedback.index.testimonials.8.author',
            imageUrl:
                '/img/avatar/lisa.png',
        },
    },
]

export default function ClientStoriesRoute() {
    const {t} = useTranslation();
    return (
        <div className="container flex flex-col justify-center pt-12 pb-48 max-w-6xl text-black">
            <div className="bg-white rounded-xl">
                <div className="mx-auto max-w-7xl px-6 lg:px-8">
                    <HeroTitle title={t('clientFeedback.index.heroTitle.title')} subject={t('clientFeedback.index.heroTitle.subject')} description={t('clientFeedback.index.heroTitle.description')} />
                    <div className="mx-auto my-16 flow-root max-w-2xl sm:mt-20 lg:mx-0 lg:max-w-none">
                        <div className="-mt-8 sm:-mx-4 sm:columns-2 sm:text-[0] lg:columns-3">
                            {testimonials2.map((testimonial) => (
                                <div key={testimonial.key} className="pt-8 sm:inline-block sm:w-full sm:px-4">
                                    <figure className="rounded-xl bg-gray-100 p-8 text-sm leading-6">
                                        <blockquote className="text-gray-900">
                                            <p>{`“${t(testimonial.body)}”`}</p>
                                        </blockquote>
                                        <figcaption className="mt-6 flex items-center gap-x-4">
                                            <img className="h-10 w-10 rounded bg-gray-50"
                                                 src={testimonial.author.imageUrl} alt=""/>
                                            <div>
                                                <div
                                                    className="font-semibold text-gray-900">{t(testimonial.author.name)}</div>
                                            </div>
                                        </figcaption>
                                    </figure>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
